module.exports = __webpack_public_path__ + "static/media/verified-org.28294c14.svg";